module.exports = __webpack_public_path__ + "media/images/fpp-banner-3-d9523c1634a34576a2d128304c463605.png";